import axios from 'axios'
import store from '../store';

// axios.defaults.baseURL = 'https://admin.trophylab.com';
// axios.defaults.baseURL = 'http://localhost:8081';

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, async function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  console.log('에러일 경우', error.config);
  const errorAPI = error.config;
  if(error.response && error.response.data && error.response.data.status===401 && errorAPI.retry===undefined){
    errorAPI.retry = true;
    console.log('토큰이 이상한 오류일 경우');
    await refreshToken();
    return axios(errorAPI);
  }
  return Promise.reject(error);
});

export async function refreshToken(){
  try{
    const lsToken = localStorage.getItem('token');
    if(lsToken != null) {
      const token = await axios
        .post('/api/admin/auth/reissue', null, {params: JSON.parse(lsToken)})
        .then(res => {
          if(res.status == 200 && res.data.statusCode == '1') {
            //console.log("user data is", res.data);
            store.commit("SET_USER_DATA", res.data.data);
          }
        })
        .catch(err => {
          console.log("reissue error",err);
          store.commit("SET_USER_DATA", null);
          // alert('로그인 해주세요');
          this.$router.push("/login");
        })
      ;
      return token;
    }
  }catch(err){
    console.log("reissue error",err);
    return err;
  }
}

export default axios;
